import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  time: '24h',
  title: 'Radio Silencio Estratégico',
  desc: "Tu objetivo hoy es dejar de 'filtrar' energía negativa. No reclames, no pidas explicaciones. Crea un vacío. El cerebro humano detesta los vacíos y empezará a llenarlos con curiosidad."
}, {
  time: '48h',
  title: 'La Micro-Validación',
  desc: "Busca un momento pequeño para reconocer algo positivo que no tenga nada que ver con la crisis. Sin segundas intenciones. Esto rompe la narrativa de que 'todo lo que ves en mí es malo'."
}, {
  time: '72h',
  title: 'La Invitación sin Presión',
  desc: "Una invitación a algo trivial y corto (un café de 15 minutos). Si dicen que no, tu respuesta debe ser: 'Entiendo, quizás en otro momento'. Esa falta de drama es tu mayor arma de seducción."
}];
export function Method() {
  return <section className="py-24 px-6 bg-cream-dark/20" data-id="element-96">
      <div className="max-w-4xl mx-auto" data-id="element-97">
        <div className="text-center mb-20" data-id="element-98">
          <h2 className="text-4xl md:text-5xl mb-4" data-id="element-99">El Método Paso a Paso</h2>
          <p className="text-lg text-charcoal-light" data-id="element-100">
            Qué hacer exactamente durante los próximos 3 días.
          </p>
        </div>

        <div className="relative" data-id="element-101">
          {/* Vertical Line */}
          <div className="absolute left-[39px] md:left-1/2 top-0 bottom-0 w-px bg-gold/30 md:-translate-x-1/2" data-id="element-102"></div>

          <div className="space-y-16" data-id="element-103">
            {steps.map((step, index) => <motion.div key={step.time} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className={`relative flex flex-col md:flex-row items-start md:items-center gap-8 md:gap-16 ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-104">
                {/* Timeline Node */}
                <div className="absolute -top-10 -left-2 md:left-1/2 w-20 h-20 bg-cream border-2 border-gold rounded-full flex items-center justify-center z-10 md:-translate-x-1/2 shadow-sm" data-id="element-105">
                  <span className="font-serif text-2xl text-navy font-semibold" data-id="element-106">
                    {step.time}
                  </span>
                </div>

                {/* Content */}
                <div className={`ml-28 md:ml-0 md:w-1/2 ${index % 2 === 0 ? 'md:text-right md:pr-20' : 'md:pl-20'}`} data-id="element-107">
                  <h3 className="text-2xl mb-3 text-navy" data-id="element-108">{step.title}</h3>
                  <p className="text-charcoal-light leading-relaxed" data-id="element-109">
                    {step.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}